if (!customElements.get('vallario-email-popup')) {
  customElements.define('vallario-email-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      if (!this.dialog || this.ready) return;
      this.ready = true;
      this.storageKey = 'vallario-newsletter-dismissed-v1';
      this.pendingKey = 'vallario-newsletter-pending-v1';
      this.preview = new URLSearchParams(window.location.search).get('vallario_popup_preview') === '1';
      this.onClose = () => {
        document.documentElement.classList.remove('vnp-page-locked');
        if (!this.preview) this.store('localStorage', this.storageKey, 'true');
        this.previousFocus?.focus({ preventScroll:true });
      };
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button,a[href],input:not([type="hidden"]),select,textarea,[tabindex]')].filter(control => !control.disabled && control.tabIndex >= 0 && control.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      });
      this.querySelector('[data-popup-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      });
      this.form?.addEventListener('submit', () => {
        if (this.form.checkValidity()) this.store('sessionStorage', this.pendingKey, 'true');
      });
      this.onSectionSelect = event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open();
      };
      document.addEventListener('shopify:section:select', this.onSectionSelect);
      const pending = this.read('sessionStorage', this.pendingKey);
      const hasResponse = this.querySelector('[data-popup-success],[data-popup-error]');
      if (this.preview || (pending && hasResponse)) {
        if (pending && hasResponse) {
          this.store('sessionStorage', this.pendingKey, '');
          if (this.querySelector('[data-popup-success]')) this.store('localStorage', this.storageKey, 'true');
        }
        this.open();
      } else if (this.dataset.enabled === 'true' && ['index','collection'].includes(this.dataset.page) && !this.read('localStorage', this.storageKey)) {
        this.timer = window.setTimeout(() => this.open(), Number(this.dataset.delay || 30) * 1000);
      }
    }
    read(storage, key) {
      try { return window[storage].getItem(key); } catch { return null; }
    }
    store(storage, key, value) {
      try { if (value) window[storage].setItem(key, value); else window[storage].removeItem(key); } catch { /* Browsing privacy settings can disable storage. */ }
    }
    open() {
      if (!this.isConnected || this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      document.documentElement.classList.add('vnp-page-locked');
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
